<template>
  <div>
    <div class="mb-1">
      <h4 class="mb-1">{{ record.phone_number }}</h4>
      <select disabled v-model="record.operator" class="form-control">
        <option value="MTS">MTS</option>
        <option value="Beeline">Beeline</option>
      </select>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          Слот
          <select v-model="record.slot" class="form-control">
            <option v-for="index in 32" :key="index" :value="index">{{ index }}</option>
          </select>
        </div>
        <div class="form-group">
          Логин в кабинет оператора
          <input v-model="record.extra.login" type="text" class="form-control">
        </div>
        <div class="form-group">
          Пароль
          <input v-model="record.extra.pass" type="text" class="form-control">
        </div>
        <div class="form-group">
          Комментарий
          <input v-model="record.extra.comment" type="text" class="form-control">
        </div>
      </div>
      <div class="col-md-6">
        <p class="mb-1">Расходы</p>
        <div class="text-right mb-1">
          <button @click="addExpenses" class="btn btn-xs btn-outline-info" type="button">Добавить расход</button>
        </div>
        <div v-for="exp in record.expenses" class="ext_block mb-2" v-if="!exp.toDelete">
          <div class="input-group">
            <input type="number" :disabled="exp.id" placeholder="Сумма" class="form-control sum_input"
                   v-model="exp.sum">
            <div class="input-group-append">
              <input :disabled="exp.id" type="text" v-model="exp.comment" placeholder="Комментарий"
                     class="form-control">
            </div>
          </div>
          <label>
            <input :disabled="exp.id" type="checkbox" v-model="exp.regular"> Регулярный расход
          </label>
          <div v-if="exp.regular">
            <p class="mb-1">Повторять каждый</p>
            <div class="input-group">
              <input :disabled="exp.id" type="number" placeholder="Период" class="form-control sum_input"
                     v-model="exp.period">
              <div class="input-group-append">
                <select :disabled="exp.id" v-model="exp.period_type" class="form-control">
                  <option value="month">Месяц</option>
                  <option value="days">День</option>
                </select>
              </div>
            </div>
          </div>
          <div class="text-right mt-1">
            <button @click="exp.toDelete = true" class="btn btn-xs btn-outline-danger" type="button">удалить расход
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['recordId', 'record'],
  created() {
    if (this.record) {
      if (!this.record.extra) {
        this.record.extra = {};
      }
      if (!this.record.expenses) {
        this.record.expenses = [];
      } else {
        this.record.expenses = this.record.expenses.map((e) => {
          return {...e, regular: true};
        })
      }
    }
  },
  methods: {
    async updatePhone() {
      let error = false;
      this.record.expenses.forEach((e) => {
        if (!e.toDelete) {
          if (!e.sum || !e.comment) {
            error = 'Не указан комментарий к расходу';
          }
          if (e.regular && (!e.period || e.period < 0)) {
            error = 'Не указан период повтора регулярного расхода';
          }
        }
      })
      if (error) {
        toastr['warning'](error);
        return false;
      }
      const {data} = await api.post('/telephony/bankPhones', {
        record: this.record
      })
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      return data.success;
    },
    addExpenses() {
      this.record.expenses.push({
        sum: 0,
        comment: '',
        period: 1,
        toDelete: false,
        period_type: 'month',
        regular: false,
      });
    }
  }
}

</script>

<style scoped>
.sum_input {
  width: 50px;
}

.ext_block {
  padding: 3px;
  border: 1px solid lightgray;
}

</style>
